import { common as enCommon } from './en/common';
import { home as enHome } from './en/home';
import { about as enAbout } from './en/about';
import { projects as enProjects } from './en/projects';
import { news as enNews } from './en/news';
import { getInvolved as enGetInvolved } from './en/getInvolved';

import { common as frCommon } from './fr/common';
import { home as frHome } from './fr/home';
import { about as frAbout } from './fr/about';
import { projects as frProjects } from './fr/projects';
import { news as frNews } from './fr/news';
import { getInvolved as frGetInvolved } from './fr/getInvolved';

import { common as swCommon } from './sw/common';
import { home as swHome } from './sw/home';
import { about as swAbout } from './sw/about';
import { projects as swProjects } from './sw/projects';
import { news as swNews } from './sw/news';
import { getInvolved as swGetInvolved } from './sw/getInvolved';

export const resources = {
  en: {
    common: enCommon,
    home: enHome,
    about: enAbout,
    projects: enProjects,
    news: enNews,
    getInvolved: enGetInvolved,
  },
  fr: {
    common: frCommon,
    home: frHome,
    about: frAbout,
    projects: frProjects,
    news: frNews,
    getInvolved: frGetInvolved,
  },
  sw: {
    common: swCommon,
    home: swHome,
    about: swAbout,
    projects: swProjects,
    news: swNews,
    getInvolved: swGetInvolved,
  },
};
